// import api from "../axiosIntercepture";

// export const fetchPOSummary = async () => {
//     try {
//         const response = await api.get("dashboard/posummary");
//         // console.log("PO Summary Response:", response.data)
//         return response.data?.data;
//     } catch (err) {
//         throw err?.response?.data?.message || "Failed to fetch PO Summary";
//     }
// };



// export const fetchAsnSummary = async () => {
//     try {
//         const response = await api.get("dashboard/asnsummary");
//         // console.log("ASN Summary Response:", response.data)
//         return response.data?.data;
//     } catch (err) {
//         throw err?.response?.data?.message || "Failed to fetch ASN Summary";
//     }
// };


// export const fetchSoSummary = async () => {
//     try {
//         const response = await api.get("dashboard/sosummary");
//         // console.log("SO Summary Response:", response.data)
//         return response.data?.data;
//     } catch (err) {
//         throw err?.response?.data?.message || "Failed to fetch SO Summary";
//     }
// };


// export const fetchShipmentSummary = async () => {
//     try {
//         const response = await api.get("dashboard/shipmentsummary");
//         // console.log("Shippment Summary Response:", response.data)
//         return response.data?.data;
//     } catch (err) {
//         throw err?.response?.data?.message || "Failed to fetch Shippment Summary";
//     }
// };



// export const fetchGrnSummary = async () => {
//     try {
//         const response = await api.get("dashboard/grnsummary");
//         console.log("GRN Summary Response:", response.data)
//         return response.data?.data;
//     } catch (err) {
//         throw err?.response?.data?.message || "Failed to fetch GRN Summary";
//     }
// };





import api from "../axiosIntercepture";

const dashboardRequest = (params = {}) => {
    const { warehouse, ...query } = params;
    const config = { params: { ...query } };
    if (warehouse) {
        config.params.warehouse = warehouse;
        config.headers = { location_id: String(warehouse).toLowerCase() };
    } else {
        config.skipLocationHeader = true;
    }
    return config;
};

export const fetchPOSummary = async (params = {}) => {
    try {
        const response = await api.get("dashboard/posummary", dashboardRequest(params));
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch PO Summary";
    }
};

export const fetchAsnSummary = async (params = {}) => {
    try {
        const response = await api.get("dashboard/asnsummary", dashboardRequest(params));
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch ASN Summary";
    }
};

export const fetchSoSummary = async (params = {}) => {
    try {
        const response = await api.get("dashboard/sosummary", dashboardRequest(params));
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch SO Summary";
    }
};

export const fetchShipmentSummary = async (params = {}) => {
    try {
        const response = await api.get("dashboard/shipmentsummary", dashboardRequest(params));
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch Shipment Summary";
    }
};

export const fetchGrnSummary = async (params = {}) => {
    try {
        const response = await api.get("dashboard/grnsummary", dashboardRequest(params));
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch GRN Summary";
    }
};

const inventoryQty = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? amount : 0;
};

const inventoryStatusName = (row) => {
    if (inventoryQty(row?.onHold) > 0) return "On Hold";
    if (inventoryQty(row?.allocated) > 0) return "Allocated";
    if (inventoryQty(row?.picked ?? row?.pickedQty ?? row?.qtyPicked) > 0) return "Picked";
    if (inventoryQty(row?.availableQty ?? row?.available) > 0 || inventoryQty(row?.stockOnHand ?? row?.onHand) > 0) {
        return "Available";
    }
    return "No Stock";
};

const summarizeInventoryRows = (rows) => {
    const list = Array.isArray(rows) ? rows : [];
    const counts = {
        Available: 0,
        Allocated: 0,
        Picked: 0,
        "On Hold": 0,
        "No Stock": 0,
    };
    let stockOnHand = 0;
    let totalOnHold = 0;
    let totalAvailable = 0;

    const items = list.map((row, index) => {
        const onHold = inventoryQty(row?.onHold);
        const stock = inventoryQty(row?.stockOnHand ?? row?.onHand);
        const available = inventoryQty(row?.availableQty ?? row?.available);
        stockOnHand += stock;
        totalOnHold += onHold;
        totalAvailable += available;
        const status = inventoryStatusName(row);
        counts[status] += 1;
        return {
            id: row?._id || `${row?.skuId || row?.item || "item"}-${index}`,
            facilityName: row?.facilityName ?? "",
            owner: row?.owner ?? "",
            item: row?.skuId ?? row?.item ?? "",
            description: row?.itemName ?? row?.description ?? "",
            unitOfMeasure: row?.uom ?? row?.unitOfMeasure ?? "",
            stockOnHand: stock,
            allocated: inventoryQty(row?.allocated),
            picked: inventoryQty(row?.picked ?? row?.pickedQty ?? row?.qtyPicked),
            onHold,
            available,
        };
    });

    return {
        summary: {
            totalInventory: list.length,
            totalQuantity: stockOnHand,
            totalOnHold,
            totalAvailable,
            avgQuantity: list.length ? stockOnHand / list.length : 0,
        },
        items,
        statusPie: Object.entries(counts).map(([name, value]) => ({ name, value })),
        yearlyData: [],
    };
};

/** Same warehouse header as Purchase Orders: selected warehouse, or every warehouse. */
const inventoryDashboardRequest = (params = {}) => {
    const warehouse = params?.warehouse;
    if (warehouse) {
        return {
            headers: { location_id: String(warehouse).toLowerCase() },
            params: { warehouse },
        };
    }
    return { skipLocationHeader: true };
};

export const fetchInventorySummary = async (params = {}) => {
    try {
        const size = 200;
        const request = inventoryDashboardRequest(params);
        let pageNo = 0;
        let collected = [];
        let total = 0;

        do {
            const response = await api.post(
                `item/getItemInventory?limit=${size}&page=${pageNo + 1}`,
                { filters: [] },
                request
            );
            const results = response.data?.results;
            const list = Array.isArray(results?.data)
                ? results.data
                : Array.isArray(results)
                    ? results
                    : [];
            total = Number(results?.totalItems ?? results?.total ?? list.length);
            collected = collected.concat(list);
            pageNo += 1;
            if (list.length === 0) break;
        } while (collected.length < total && pageNo < 40);

        return summarizeInventoryRows(collected);
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch Inventory Summary";
    }
};

/** Same export as Item Inventory: file is generated for Tools > Excel Imports/Exports. */
export const exportInventoryItemSummary = async (warehouse) => {
    const config = warehouse
        ? { headers: { location_id: String(warehouse).toLowerCase() } }
        : { skipLocationHeader: true };
    try {
        const response = await api.post("item/ItemInventory/export", [], config);
        return response.data?.message;
    } catch (err) {
        throw err?.response?.data?.message || "Export failed";
    }
};
